import { Segmented } from "antd";
import { useState } from "react";
import { useLocation } from "react-router-dom";
import ProfileInfo from "./ProfileInfo/profileinfo";
import HistoryAction from "./HistoryAction/HistoryAction";
import Balance from "./Balance/Balance";

const ActionTabs = ({ styles }) => {
	const location = useLocation();
	const [actionTabs, setActionTabs] = useState({
		activeTab: "profile",
		purchase: location?.state || {},
	});
	return (
		<>
			<div className="holder-tab">
				<Segmented
					className="segment-class"
					onChange={(value) => setActionTabs((active) => ({ ...active, activeTab: value }))}
					options={[
						{ label: "اطلاعات مشترک", value: "profile" },
						{ label: "سوابق", value: "history" },
						{ label: "باقیمانده", value: "leftover" },
					]}
					size="large"
					block
				/>
				{actionTabs.activeTab === "profile" && <ProfileInfo purchase={actionTabs?.purchase} styles={styles} />}
				{actionTabs.activeTab === "history" && <HistoryAction purchase={actionTabs?.purchase} styles={styles} />}
				{actionTabs.activeTab === "leftover" && <Balance purchase={actionTabs?.purchase} styles={styles} />}
			</div>
		</>
	);
};

export default ActionTabs;
